import React from 'react';
import styles from '../StoreGuide.module.scss';
import SupportEmailLink from '../../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../../components/DiscordInviteButton/DiscordInviteButton';

const EAPlayGuide: React.FC = () => {
  return (
    <div className={styles.guideContent}>
      <div className={styles.guideHeader}>
        <img 
          src={`${process.env.PUBLIC_URL}/images/logos/ea-play-logo.svg`}
          alt="EA Play"
          className={styles.storeLogo}
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.style.display = 'none';
          }}
        />
        <div className={styles.storeTitle}>
          <h1>Product Key Activation on EA Play</h1>
          <p>
            You can activate your EA Activation Key via{' '}
            <a 
              href="https://www.ea.com/games/library/pc-download" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.inlineLink}
            >
              downloading the EA Client App
            </a>
            {' '}for your PC or via the{' '}
            <a 
              href="https://www.ea.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.inlineLink}
            >
              Electronic Arts website.
            </a>
          </p>
        </div>
      </div>

      <div className={styles.stepsContainer}>
        
        {/* Via App Section */}
        <div className={styles.methodSection}>
          <h2 className={styles.methodTitle}>Via App:</h2>
          <div className={styles.steps}>
            
            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>1</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Select My Collection and Redeem Code</h3>
                <div className={styles.stepDescription}>
                  Select the <strong className={styles.boldText}>My Collection</strong> and click on <strong className={styles.boldText}>Redeem Code.</strong>
                </div>
                <div className={styles.stepImage}>
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/activation-guides/ea-app-step-1.png`}
                    alt="Step 1: Select My Collection and Redeem Code"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.onerror = null;
                      target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>2</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Enter Activation Key</h3>
                <div className={styles.stepDescription}>
                  Enter your activation key in the dialog box and ensure that you've left no empty spaces before or after the code.
                </div>
                <div className={styles.stepImage}>
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/activation-guides/ea-app-step-2.png`}
                    alt="Step 2: Enter activation key"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.onerror = null;
                      target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>3</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Complete Activation</h3>
                <div className={styles.stepDescription}>
                  Click on <strong className={styles.boldText}>Next</strong> and enjoy!
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Via Website Section */}
        <div className={styles.methodSection}>
          <h2 className={styles.methodTitle}>EA Website:</h2>
          <div className={styles.steps}>
            
            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>1</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Log in to Your Account</h3>
                <div className={styles.stepDescription}>
                  Log in to your account and go to the accounts page.
                </div>
                <div className={styles.stepImage}>
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/activation-guides/ea-website-step-1.png`}
                    alt="Step 1: Log in to your account"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.onerror = null;
                      target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>2</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Select Redeem Product Code</h3>
                <div className={styles.stepDescription}>
                  Select the <strong className={styles.boldText}>Redeem Product Code</strong> option on the left side of your screen
                </div>
                <div className={styles.stepImage}>
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/activation-guides/ea-website-step-2.png`}
                    alt="Step 2: Select Redeem Product Code"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.onerror = null;
                      target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>3</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Enter Activation Key</h3>
                <div className={styles.stepDescription}>
                  Enter your key in the <strong className={styles.boldText}>Activation field</strong> and make sure there are no extra spaces before or after the code.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>4</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Complete Process</h3>
                <div className={styles.stepDescription}>
                  Click Next and enjoy!
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>5</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>OnePlay Support</h3>
                <div className={styles.stepDescription}>
                  <div style={{ marginBottom: '12px' }}>
                  For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                </div>
                <DiscordInviteButton />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* <div className={styles.additionalNotes}>
        <h3>Important Notes</h3>
        <ul>
          <li>EA Play gift cards can be used for EA games and in-game purchases</li>
          <li>Codes are region-specific and must match your account region</li>
          <li>Some content may require additional purchases</li>
        </ul>
      </div>

      <div className={styles.support}>
        <h3>Need More Help?</h3>
        <p>
          If you encounter any issues during the activation process, visit the official{' '}
          <a 
            href="https://help.ea.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.supportLink}
          >
            EA Play Support Center
          </a>
          {' '}for additional assistance.
        </p>
      </div> */}
    </div>
  );
};

export default EAPlayGuide; 